// extracted by mini-css-extract-plugin
export default {"top":"GuidelinesAndLinks__top___ZHiMq","linksContainer":"GuidelinesAndLinks__linksContainer___5kYP8","subtitle":"GuidelinesAndLinks__subtitle___8OWeo"};